const pages = [
  {
    directory: "registration",
    url: "login",
    privateRoute: false,
    index: false,
    children: [],
  },
  {
    directory: "products",
    url: "products",
    privateRoute: true,
    index: true,
    children: [],
  },
];

export default pages;
